import React, { Component } from 'react';
import Sound from '../UI/Sound';
import withActivityAnalytics from '../../hoc/WithActivityAnalytics';
import {isEmpty} from '@lsgo/lsgo-common/utils';
import { TYPES } from '../../constants/activityTypes';

class QuizOpenEnded extends Component {
    constructor(props) {
        super(props);

        this.state = {
            text: null,
            tries: 0,
            skip: false,
        };

        this.onTextAreaChange = this.onTextAreaChange.bind(this);
        this.handleDone = this.handleDone.bind(this);

        const { demoMode } = this.props;
    }

    onTextAreaChange(event) {
        this.setState({ text: event.target.value });
    }

    handleDone() {
        const { text } = this.state;
        const { activityId, startTime } = this.props;

        if (text === null || text === '') {
            this.props.dispatchAddAlert('Have a try');
            this.setState({
                tries: this.state.tries + 1,
                skip: true,
            });
            return false;
        }

        this.props.dispatchAddToScore('brain', 1);

        const endTime = this.props.endTime();
        const resultObj = {
            text,
            teacherAssessed: 0,
            correct: 0,
        };

        this.props.pushActivityAnalytics(startTime, endTime, TYPES.QUIZ_TEXT_FIELD.ID, activityId, resultObj);
        this.props.activityDone();
    }

    render() {
        const { question, questionImage, questionSound, demoMode, title } = this.props;
        const { skip } = this.state;

        return (
            <div className='quiz-wrapper'>
                <div className='quiz-content text'>
                    <div className='quiz-question'>
                        <h3>{question ? question : title ? title : ''}</h3>
                        {questionImage && (
                            <div className='quiz-question-img'>
                                <img alt={question} src={questionImage} />
                            </div>
                        )}
                        {questionSound && <Sound audioUrl={questionSound} />}
                    </div>
                    <div className='quiz-textarea'>
                        <textarea onChange={this.onTextAreaChange} />
                    </div>
                </div>

                {!demoMode && (
                    <div
                        style={{
                            marginBottom: 10,
                            marginTop: 15,
                            display: 'flex',
                            justifyContent: 'flex-end',
                        }}
                    >
                        <button className='student-submit-btn' onClick={this.handleDone}>
                            {skip ? 'NEXT' : 'SUBMIT'}
                        </button>
                    </div>
                )}
            </div>
        );
    }
}

export default withActivityAnalytics(QuizOpenEnded);
